import React from 'react'
import styles from './Stepper.module.scss'

export default function Stepper({
	totalSteps = 3,
	subSteps = 4,
	activeStep = '1',
}) {
	// Build steps dynamically
	const steps = []
	for (let i = 1; i <= totalSteps; i++) {
		steps.push({ type: 'main', label: `${i}` })

		if (i < totalSteps) {
			for (let j = 1; j <= subSteps; j++) {
				const subLabel = `${i}.${j * (10 / subSteps)}` // 1.2, 1.4, ...
				steps.push({ type: 'sub', label: subLabel })
			}
		}
	}

	// Ensure activeStep is string
	const stepString = String(activeStep)
	const [aMain, aSub = 0] = stepString.split('.').map(Number)

	// Check if step is active
	const isStepActive = (label) => {
		const [sMain, sSub = 0] = label.split('.').map(Number)
		if (sMain < aMain) return true
		if (sMain === aMain && sSub <= aSub) return true
		return false
	}

	return (
		<div className={styles.stepper}>
			{steps.map((step, index) => {
				const active = isStepActive(step.label)
				return (
					<div
						key={index}
						className={`${styles.step} ${
							step.type === 'main' ? styles.main : styles.sub
						} ${active ? styles.active : ''}`}
					></div>
				)
			})}
		</div>
	)
}
